import { render, staticRenderFns } from "./VngLogo.vue?vue&type=template&id=3dce5e50&"
import script from "./VngLogo.vue?vue&type=script&lang=js&"
export * from "./VngLogo.vue?vue&type=script&lang=js&"
import style0 from "./VngLogo.vue?vue&type=style&index=0&id=3dce5e50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports